export const steps = [
    {
        "name": "Identidade",
        "fullName": "Identidade",
        "past": false,
        "valid": false,
        "validate": (state) => {
            let process = state.process;
            let step = state.steps[state.currentStep];

            step.valid = true;

            state.validationErrors.invalidDate = false;
            state.validationErrors.nullNallme = false;
            state.validationErrors.nullStartDate = false;
            state.validationErrors.nullEndDate = false;
            state.validationErrors.repeatedName = false;
            state.validationErrors.nullPriceSubscription = false;
            state.validationErrors.minPriceError = false;

            if (!(process.name && process.startDate && process.endDate)) {
                step.valid = false;
                state.validationErrors.nullName = !process.name;
                state.validationErrors.nullStartDate = !process.startDate;
                state.validationErrors.nullEndDate = !process.endDate;
            }

            if (process.name) {
                state.processesList.forEach((data) => {
                    if (data.name === process.name && process.key !== data.key) {
                        step.valid = false;
                        state.validationErrors.repeatedName = true;
                    }
                });
            }

            if (process.startDate && process.endDate && (process.startDate >= process.endDate)) {
                step.valid = false;
                state.validationErrors.invalidDate = true;
            }

            if (state.validationErrors.maximumSizeDescription) {
                step.valid = false;
            }

            if(!process.typePayment && !process.priceSubscription) {
                step.valid = false;
                state.validationErrors.nullPriceSubscription = true;
            }

            if(!process.typePayment && process.priceSubscription === null) {
                step.valid = false;
                state.validationErrors.minPriceError = true;
            }

            if(!process.typePayment && parseFloat(process.priceSubscription) < 10){
                step.valid = false;
                state.validationErrors.minPriceError = true;
            }
        }
    },
    {
        "name": "Cursos",
        "fullName": "Cadastro de Cursos",
        "past": false,
        "valid": false,
        "validate": (state) => {
            let process = state.process;
            let step = state.steps[state.currentStep];

            step.valid = true;

            state.validationErrors.nullUnit = false;
            state.validationErrors.nullUnitCourse = false;

            if (process.processUnits.length > 1) {
                process.processUnits.forEach((processUnit) => {
                    if (!processUnit.selectedUnit) {
                        step.valid = false;
                        state.validationErrors.nullUnit = true;
                    }
                })
            }

            process.processUnits.forEach((processUnit, index) => {
                state.validationErrors.processUnitErrors[index].nullTestDayTime = [];
                state.validationErrors.processUnitErrors[index].nullTestTemplate = [];
                if (processUnit.unitCourses.length === 0) {
                    step.valid = false;
                    state.validationErrors.nullUnitCourse = true;
                }
                processUnit.unitCourses.forEach((unitCourse) => {
                    if (!unitCourse.dayTime.find((marked) => marked === true)) {
                        step.valid = false;
                        state.validationErrors.processUnitErrors[index].nullTestDayTime.push(unitCourse.id);
                    }

                    if (!unitCourse.testTemplateId && !state.process.withoutTest) {
                        step.valid = false;
                        state.validationErrors.processUnitErrors[index].nullTestTemplate.push(unitCourse.id);
                    }

                })
            });
        }
    },
    {
        "name": "Provas",
        "fullName": "Datas de Prova",
        "past": false,
        "valid": false,
        "validate": (state) => {
            let process = state.process;
            let step = state.steps[state.currentStep];

            step.valid = true;

            if (!state.process.withoutTest) {
                process.processUnits.forEach((processUnit, index) => {
                state.validationErrors.processUnitErrors[index].nullTestDatesEnd = [];
                state.validationErrors.processUnitErrors[index].nullTestDatesDate = [];
                state.validationErrors.processUnitErrors[index].nullTestDuration = [];
                state.validationErrors.processUnitErrors[index].invalidTestDate = [];
                state.validationErrors.processUnitErrors[index].nullTestDatesPlace = [];

                if (processUnit.testType !== 'D') {

                    let testDate;
                    let startDate = process.startDate;
                    let invalidDate;

                    processUnit.testTimes.forEach((testTime) => {
                        if (testTime.endDate === '' || !testTime.endDate) {
                            step.valid = false;
                            state.validationErrors.processUnitErrors[index].nullTestDatesEnd.push(true)
                        } else {
                            state.validationErrors.processUnitErrors[index].nullTestDatesEnd.push(false)

                            invalidDate = false;
                            testTime.dateList.forEach((date) => {
                                testDate = date;
                                if (testDate < startDate) {
                                    invalidDate = true;
                                }
                            });

                            if (invalidDate) {
                                step.valid = false;
                                state.validationErrors.processUnitErrors[index].invalidTestDate.push(true);
                            } else {
                                state.validationErrors.processUnitErrors[index].invalidTestDate.push(false);
                            }
                        }

                        if (testTime.dateList.filter((dateDict) => dateDict.id !== null).length === 0) {
                            step.valid = false;
                            state.validationErrors.processUnitErrors[index].nullTestDatesDate.push(true)
                        } else {
                            state.validationErrors.processUnitErrors[index].nullTestDatesDate.push(false)
                        }

                        if (!testTime.duration) {
                            step.valid = false;
                            state.validationErrors.processUnitErrors[index].nullTestDuration.push(true)
                        } else {
                            state.validationErrors.processUnitErrors[index].nullTestDuration.push(false)
                        }

                    })
                }
                if (processUnit.testType === 'P') {
                    processUnit.testTimes.forEach((testTime) => {
                        if (!testTime.place) {
                            step.valid = false;
                            state.validationErrors.processUnitErrors[index].nullTestDatesPlace.push(true)
                        } else {
                            state.validationErrors.processUnitErrors[index].nullTestDatesPlace.push(false)
                        }
                    });
                }
            });
            }

        }
    },
    {
        "name": "Inscrição",
        "fullName": "Inscrição do Aluno",
        "past": false,
        "valid": false,
        "validate": (state) => {
            let process = state.process;
            let step = state.steps[state.currentStep];
            let labels = [];

            step.valid = true;

            state.validationErrors.nullnewOption = [];
            state.validationErrors.nullnewField = [];
            state.validationErrors.equalnewField = [];

            process.form.fields.forEach((field, index) => {
                if (field.label === '') {
                    step.valid = false;
                    state.validationErrors.nullnewField[index] = true;
                } else {
                    state.validationErrors.nullnewField[index] = false;
                }

                if (labels.find((label) => label === field.label)) {
                    step.valid = false;
                    state.validationErrors.equalnewField[index] = true;
                } else {
                    state.validationErrors.equalnewField[index] = false;
                }
                labels.push(field.label);

                if (field.type === 'SC' || field.type === 'MC') {
                    if (field.choices.length === 0) {
                        step.valid = false;
                        state.validationErrors.nullnewOption[index] = true;
                    } else {
                        state.validationErrors.nullnewOption[index] = false;
                    }
                }
            });
        }
    },
    {
        "name": "Classificação",
        "fullName": "Regras de Classificação",
        "past": false,
        "valid": false,
        "validate": (state) => {
            let step = state.steps[state.currentStep];
            step.valid = true;
        }
    }
];
